/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */

import { SearchService } from '@/app/services/ia-services/search.service';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { PillComponent } from '@/app/shared/pill/pill.component';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal, computed } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DesyAngularModule } from 'desy-angular';
import { AutoComplete } from 'primeng/autocomplete';
import { DatePickerComponent } from '@/app/shared/date-picker/date-picker.component';
import { SystemsService } from '@/app/services/ia-services/systems.service';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { getError } from '@/app/utils/form-errors';
import { requiredNonEmptyArray } from '@/app/utils/required-non-empty-array.validator';
import { requiredSelect } from '@/app/utils/required-select.validator';
import { requiredProject } from '@/app/utils/required-project.validator';
import { taskFunctions } from '@/app/shared/mappers/task-function-label.mapper';
@Component({
  selector: 'app-system-form',
  templateUrl: './new-system-of-ia.component.html',
  styleUrls: ['./new-system-of-ia.component.scss'],
  imports: [
    ConfirmDialog,
    DesyAngularModule,
    ButtonsComponent,
    FormsModule,
    ReactiveFormsModule,
    AutoComplete,
    CommonModule,
    PillComponent,
    DatePickerComponent,
  ],
  providers: [ConfirmationService],
})
export class NewSystemOfIaComponent implements OnInit {
  private systemService = inject(SystemsService);
  private readonly userData = JSON.parse(localStorage.getItem('userData') || '{}');

  autogeneratedItems: any[] = [];

  name = 'taskOrFunctions';
  id = '1';
  type: 'radio' | 'checkbox' = 'checkbox';
  valueContent: any[] = [];
  idPrefix = 'item';

  form!: FormGroup;
  getError = getError;
  projectList: any[] = [];
  searchService = inject(SearchService);
  projectSearchLoading = signal(false);
  private projectSearchRequestId = 0;
  minSelectableDate = this.getTodayDate();

  otherFunctions = signal([]);
  otherFunction = signal('');

  typeSystem = [
    { label: 'Sistema conversacional', value: 8 },
    { label: 'Sistema de análisis y extracción de información', value: 7 },
    { label: 'Sistema de recomendación y personalización', value: 6 },
    { label: 'Sistema predictivo y de apoyo de la decisión', value: 5 },
    { label: 'Sistema para la automatización inteligente de procesos', value: 4 },
    { label: 'Sistema de detección y supervisión', value: 3 },
    { label: 'Sistema a medida con funciones críticas o sensibles', value: 2 },
    { label: 'Otros', value: 1 },
  ];
  tasksFunctions = taskFunctions;
  explainabilityLevelOptions = [
    { label: 'Baja', value: 1 },
    { label: 'Medio', value: 2 },
    { label: 'Alto', value: 3 },
  ];

  administrationRoleOptions = [
    { value: 1, label: 'Representante' },
    { value: 2, label: 'Fabricante' },
    { value: 3, label: 'Importador' },
    { value: 4, label: 'Distribuidor' },
    { value: 5, label: 'Desplegador' },
    { value: 6, label: 'Proveedor' },
  ];

  dataTypeOptions = [
    { value: 1, label: 'Documentos' },
    { value: 2, label: 'Páginas' },
    { value: 3, label: 'Consultas' },
    { value: 4, label: 'Registros' },
    { value: 5, label: 'Imágenes' },
    { value: 6, label: 'Vídeo/Audio' },
    { value: 7, label: 'Datos estructurados' },
    { value: 8, label: 'Formularios' },
    { value: 9, label: 'Otros' },
  ];

  systemProviderOptions = [
    { value: 'Interno', label: 'Interno' },
    { value: 'Externo', label: 'Externo' },
    { value: 'Ambos', label: 'Ambos' },
  ];
  systemClassificationOptions = [
    { value: 'inaceptable', label: 'Inaceptable' },
    { value: 'alto', label: 'Alto' },
    { value: 'limitado', label: 'Limitado' },
    { value: 'minimo', label: 'Mínimo' },
  ];

  showOtherInput = signal(false);

  idProject = signal('');
  nameProject = signal('');
  codeProject = signal('');
  orgCodeProject = signal('');
  isProjectAutofilled = signal(false);

  infoProject = computed(() => ({
    codigo_proyecto: this.idProject(),
    codigo_proyecto_solicitud: this.codeProject(),
    proyecto: this.nameProject(),
    codigo_organismo: this.orgCodeProject(),
  }));
  codigo_proyecto;
  codigo_proyecto_solicitud;
  proyecto;
  get projectOptions() {
    return this.projectList;
  }

  filteredFunctionOfSystem: string[] = [];

  formSubmitted = signal(false);
  constructor(
    private fb: FormBuilder,
    private location: Location,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      projectCodes: [
        {
          codigo_proyecto: this.idProject(),
          codigo_proyecto_solicitud: this.codeProject(),
          proyecto: this.nameProject(),
          codigo_organismo: this.orgCodeProject(),
        },
        requiredProject,
      ],

      systemName: ['', [Validators.required, Validators.pattern(/^[^:#]*$/)]],
      systemType: [null, Validators.required],
      otherSystemType: [{ value: '', disabled: true }],
      functionOfSystem: [[], requiredNonEmptyArray],
      otherFunctions: [[], []],
      description: ['', [Validators.required, Validators.maxLength(500)]],
      estimatedDeployDate: [null, Validators.required],
      estimatedFunctionalInputVolume: [null, Validators.required],
      dataType: [0, requiredSelect],
      otherDataType: [{ value: '', disabled: true }],
      administrationRole: [0, requiredSelect],
      explainabilityLevel: [0, requiredSelect],
      contractingImport: [null, Validators.required],
      annualAmount: [null, Validators.required],
      estimatedAnnualSavings: [null, Validators.required],
      lastModifiedDate: [null],
      contractValidity: [null, [Validators.min(0), Validators.required]],
      contractValidityDate: [null, Validators.required],
      aiSystemProviderType: [null, Validators.required],
      aiProviderName: [null, [Validators.required, Validators.maxLength(100)]],
      aiModelName: [null, [Validators.required, Validators.maxLength(200)]],
      systemClassification: [null, Validators.required],
    });

    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      const name = decodeURIComponent(params.get('name') || '');
      const code = params.get('code');
      const orgCode = params.get('orgcode');

      const nameWithSpace = name.replace(/_/g, ' ');

      this.idProject.set(id ?? '');
      this.nameProject.set(nameWithSpace ?? '');
      this.codeProject.set(code ?? '');
      this.orgCodeProject.set(orgCode ?? '');

      this.form.get('projectCodes')?.patchValue(this.infoProject());
      this.isProjectAutofilled.set(!!id);

      if (id) {
        this.form.get('projectCodes')?.disable();
      }
    });
    this.form.get('functionOfSystem')?.valueChanges.subscribe(() => {
      this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });
    this.form.get('otherFunctions')?.valueChanges.subscribe(() => {
      this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    this.autogeneratedItems = this.tasksFunctions.map((group) => ({
      id: group.value,
      value: group.value,
      label: group.label,
      expanded: false,
      disabled: false,
      sub: {
        items: group.children.map((child) => ({
          id: child.value,
          value: child.value,
          label: child.label,
          expanded: false,
          disabled: false,
          sub: { items: [] },
        })),
      },
    }));

    this.form.get('systemType')?.valueChanges.subscribe((value) => {
      this.onSystemTypeChange(value);
    });
    this.form.get('dataType')?.valueChanges.subscribe((value) => {
      this.onDataTypeChange(value);
    });

    this.form.get('functionOfSystem')?.valueChanges.subscribe((selectedValues: any[]) => {
      this.filteredFunctionOfSystem = this.mapTreeSelectionToChildren(selectedValues);
    });
  }

  private getTodayDate(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  async onSave() {
    try {
      const formData = this.form.getRawValue();
      formData.functionOfSystem = this.deleteNumber(formData.functionOfSystem);

      if (this.form.get('otherSystemType')?.disabled) {
        formData.otherSystemType = null;
      }
      if (this.form.get('otherDataType')?.disabled) {
        formData.otherDataType = null;
      }
      const jobcode = this.form.get('jobcode')?.value;
      const resp = await this.systemService.createNewSystem(formData);
      console.log('✅ Sistema creado en backend:', resp);

      this.form.reset();
      this.form.get('jobcode')?.setValue(jobcode);
      this.router.navigate(['/catalogo-ia/sistemas-de-ia/listado-sistemas']);
    } catch (err) {
      console.error('❌ Error al crear sistema:', err);
    }
  }

  get otherSystemTypeControl(): FormControl {
    return this.form.get('otherSystemType') as FormControl;
  }
  get otherDataTypeControl(): FormControl {
    return this.form.get('otherDataType') as FormControl;
  }
  get isOtherDataTypeSelected(): boolean {
    return Number(this.form.get('dataType')?.value) === 9;
  }
  onSystemTypeChange(value: number) {
    if (value === 1) {
      this.otherSystemTypeControl.enable();
      this.otherSystemTypeControl.setValidators([Validators.required, Validators.pattern(/^[^:#]*$/)]);
    } else {
      this.otherSystemTypeControl.clearValidators();
      this.otherSystemTypeControl.setValue(null);
      this.otherSystemTypeControl.disable();
    }
    this.otherSystemTypeControl.updateValueAndValidity();
  }
  onDataTypeChange(value: number) {
    if (Number(value) === 9) {
      this.otherDataTypeControl.enable();
      this.otherDataTypeControl.setValidators([Validators.required, Validators.pattern(/^[^:#]*$/)]);
    } else {
      this.otherDataTypeControl.clearValidators();
      this.otherDataTypeControl.setValue(null);
      this.otherDataTypeControl.disable();
    }
    this.otherDataTypeControl.updateValueAndValidity();
  }

  updateSystemType(value: string) {
    this.form.get('systemType')?.setValue(value);
  }

  async onSearchProjects(event) {
    const query = `${event?.query ?? ''}`.trim();

    if (query.length < 3) {
      this.projectList = [];
      this.projectSearchLoading.set(false);
      return;
    }

    const requestId = ++this.projectSearchRequestId;
    this.projectList = [];
    this.projectSearchLoading.set(true);

    try {
      const response: any = await this.searchService.search({
        search: query,
        busqueda: 'proyectos',
        orgcode: this.userData.orgCode,
        jobcode: this.userData.roleCode,
      });

      if (requestId === this.projectSearchRequestId) {
        this.projectList = response.data || [];
      }
    } finally {
      if (requestId === this.projectSearchRequestId) {
        this.projectSearchLoading.set(false);
      }
    }
  }

  onProjectSelected(event: any) {
    const selected = event.value;
    this.projectList = [];
    this.form.patchValue({
      projectCodes: {
        codigo_proyecto: selected.codigo_proyecto,
        codigo_proyecto_solicitud: selected.codigo_proyecto_solicitud,
        proyecto: selected.proyecto,
        codigo_organismo: selected.codigo_organismo,
      },
    });
  }

  addFunctions(event?: MouseEvent) {
    event?.preventDefault();

    const value = this.otherFunction();

    if (value && value.trim() !== '') {
      this.otherFunctions.update((apps) => [...apps, value.trim()]);

      this.form.get('otherFunctions')?.setValue(this.otherFunctions());
      this.updateFunctionOfSystemValidators();
      this.otherFunction.set('');
    }
  }

  removeFunctions(item: string) {
    this.otherFunctions.update((apps) => apps.filter((a) => a !== item));
    this.form.get('otherFunctions')?.setValue(this.otherFunctions());
    this.updateFunctionOfSystemValidators();
  }

  private updateFunctionOfSystemValidators(): void {
    const control = this.form.get('functionOfSystem');

    if (this.otherFunctions().length > 0) {
      control?.clearValidators();
    } else {
      control?.setValidators(requiredNonEmptyArray);
    }

    control?.updateValueAndValidity({ emitEvent: false });
  }
  onTreeSelectionChange(selectedValues: string[]) {
    const onlyChildren = this.mapTreeSelectionToChildren(selectedValues);
    const onlyChildrenFilter = onlyChildren.filter((x) => x != null && typeof x !== 'number');

    this.form.get('functionOfSystem')?.setValue(onlyChildrenFilter);
  }
  private mapTreeSelectionToChildren(selectedValues: (string | number)[] | null | undefined): string[] {
    const values = Array.isArray(selectedValues) ? selectedValues : [];
    const result: string[] = [];
    values.forEach((val) => {
      const group = this.tasksFunctions.find((g) => g.value === Number(val));

      if (group) {
        group.children?.forEach((child) => {
          if (!result.includes(child.value)) {
            result.push(child.value);
          }
        });
      } else if (typeof val === 'string') {
        if (!result.includes(val)) {
          result.push(val);
        }
      }
    });
    return result;
  }
  private deleteNumber(value: Array<any>) {
    return value.filter((item) => typeof item !== 'number');
  }

  backPage(): void {
    this.location.back();
  }

  confirm() {
    this.formSubmitted.set(true);
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) {
      return;
    }
    this.confirmationService.confirm({
      message: '¿Seguro que desea registrar el sistema.?',
      header: 'Confirmación',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Guardar',
      },
      accept: async () => {
        await this.onSave();
      },
    });
  }
}
